import React, { useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import { useLocation } from "react-router-dom";
import { MdCloudDone } from "react-icons/md";
import { FcExpired } from "react-icons/fc";
import axiosForgetPasswordInstance from "../axios/AxiosForget";
import * as Yup from "yup";
import { BiHide, BiShow } from "react-icons/bi";

const validationSchema = Yup.object({
  password: Yup.string()
    .required("Password is required")
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
      "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character"
    ),
  password2: Yup.string()
    .required("Confirm Your Password")
    .oneOf([Yup.ref("password"), null], "Password must match"),
});

function NewPassword() {
  const [Show, setShow] = useState(false);
  const [Show2, setShow2] = useState(false);
  const search = useLocation().search;
  const uidb64 = new URLSearchParams(search).get("uidb64");
  const token = new URLSearchParams(search).get("token");
  const [ShowSuccessMsg, setShowSuccessMsg] = useState(false);
  const Expire = new URLSearchParams(search).get("token_valid");

  const initialValues = {
    password: "",
    password2: "",
    token: token,
    uidb64: uidb64,
  };
  const onSubmit = (values, onSubmitProps) => {
    console.log("Form Data", values);
    axiosForgetPasswordInstance
      .patch("/users/password_reset/confirm/", values)
      .then((res) => {
        setShowSuccessMsg(true);
      })
      .catch((error) => {
        console.log("error");
        onSubmitProps.setSubmitting(false);
      });
  };

  return (
    <>
      <div className="min-h-full flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          {!ShowSuccessMsg ? (
            <>
              {Expire == "True" ? (
                <>
                  <div>
                    <h2 className="mt-32 text-left font-Montserrat text-2xl font-bold text-black">
                      Create new password
                    </h2>
                    <div className="border-b-2 border-blue-200 w-24"></div>
                  </div>
                  <Formik
                    initialValues={initialValues}
                    onSubmit={onSubmit}
                    validationSchema={validationSchema}
                    validateOnMount
                  >
                    <Form className="mt-8 space-y-10">
                      <Field name="password">
                        {(props) => {
                          const { field, form, meta } = props;
                          return (
                            <div className="my-12">
                              <>
                                <div className="relative text-gray-600 focus-within:text-gray-400">
                                  <span className="absolute inset-y-0 left-96 flex items-center pl-2">
                                    <button
                                      type="button"
                                      onClick={() => setShow(!Show)}
                                      className="p-5 focus:outline-none focus:shadow-outline"
                                    >
                                      {!Show ? (
                                        <BiHide size={25} />
                                      ) : (
                                        <BiShow size={25} />
                                      )}
                                    </button>
                                  </span>
                                  <input
                                    {...field}
                                    type={!Show ? "password" : "text"}
                                    {...(meta.touched && meta.error
                                      ? {
                                          className:
                                            "border-b-2 block w-full px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                        }
                                      : {
                                          className:
                                            "border-b-2 block w-full px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                                        })}
                                    placeholder="Password"
                                    con
                                  ></input>
                                </div>
                                {meta.touched && meta.error ? (
                                  <label className="text-xs font-semibold font-Montserrat text-red-500">
                                    <span className="ml-1">{meta.error}</span>
                                  </label>
                                ) : null}
                              </>
                            </div>
                          );
                        }}
                      </Field>
                      <Field name="password2">
                        {(props) => {
                          const { field, form, meta } = props;
                          return (
                            <div className="my-12">
                              <>
                                <div className="relative text-gray-600 focus-within:text-gray-400">
                                  <span className="absolute inset-y-0 left-96 flex items-center pl-2">
                                    <button
                                      type="button"
                                      onClick={() => setShow2(!Show2)}
                                      className="p-5 focus:outline-none focus:shadow-outline"
                                    >
                                      {!Show2 ? (
                                        <BiHide size={25} />
                                      ) : (
                                        <BiShow size={25} />
                                      )}
                                    </button>
                                  </span>
                                  <input
                                    {...field}
                                    type={!Show2 ? "password" : "text"}
                                    {...(meta.touched && meta.error
                                      ? {
                                          className:
                                            "border-b-2 block w-full px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                        }
                                      : {
                                          className:
                                            "border-b-2 block w-full px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                                        })}
                                    placeholder="Password"
                                    con
                                  ></input>
                                </div>
                                {meta.touched && meta.error ? (
                                  <label className="text-xs font-semibold font-Montserrat text-red-500">
                                    <span className="ml-1">{meta.error}</span>
                                  </label>
                                ) : null}
                              </>
                            </div>
                          );
                        }}
                      </Field>
                      <Field>
                        {(props) => {
                          const { field, form, meta } = props;
                          const { isSubmitting } = form;
                          return (
                            <>
                              {!isSubmitting ? (
                                <button
                                  type="submit"
                                  {...(form.isValid
                                    ? {
                                        className:
                                          "font-Montserrat font-semibold text-white flex-shrink bg-blue-200 hover:bg-blue-100 place-content-center w-full rounded-sm px-4 py-2 flex flex-grow ",
                                      }
                                    : {
                                        disabled: true,
                                        className:
                                          "font-Montserrat font-semibold text-white flex-shrink bg-blue-200 hover:bg-blue-100 place-content-center w-full rounded-sm px-4 py-2 flex flex-grow opacity-50 cursor-not-allowed",
                                      })}
                                >
                                  Confirm
                                </button>
                              ) : (
                                <button
                                  disabled
                                  className="font-Montserrat font-semibold flex-shrink bg-blue-200 place-content-center w-full rounded-sm px-4 py-2 flex flex-grow"
                                >
                                  <div className="flex items-center justify-center space-x-2 animate-pulse">
                                    <svg className="w-5 h-5 bg-blue-300 rounded-full"></svg>
                                    <svg className="w-5 h-5 bg-blue-300 rounded-full"></svg>
                                    <svg className="w-5 h-5 bg-blue-300 rounded-full"></svg>
                                  </div>
                                </button>
                              )}
                            </>
                          );
                        }}
                      </Field>
                    </Form>
                  </Formik>
                </>
              ) : (
                <div className="mt-32 ">
                  <div>
                    <FcExpired color="#1F78B4" size={75} />
                  </div>
                  <h2 className="text-left font-Montserrat text-2xl font-bold text-black">
                    Your verification link is expired please sign up again
                  </h2>
                  <div className="border-b-2 border-blue-200 w-24"></div>
                </div>
              )}
            </>
          ) : (
            <div className="mt-32 ">
              <div>
                <MdCloudDone color="#1F78B4" size={75} />
              </div>
              <h2 className="text-left font-Montserrat text-2xl font-bold text-black">
                Your password is successfully changed
              </h2>
              <div className="border-b-2 border-blue-200 w-24"></div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default NewPassword;
